<template>
  <RygenMultiSelect
    :id="id"
    v-model="internalValue"
    :disabled="disabled"
    :loading="loading"
    :options="options"
    :placeholder="placeholder"
    display="chip"
    class="order-status-multi-select"
    option-label="label"
    option-value="value"
    filter
  >
    <template #chip="{ value }">
      <OrderChip :status="value" />
    </template>

    <template #option="{ option }">
      <OrderChip :status="option.value" />
    </template>
  </RygenMultiSelect>
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs, useAttrs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue, useUid } from '@rygen/rygen-ui/composables';
import { mapEnumToTranslatedDropdownValues } from '@rygen/rygen-ui/i18n';

import { OrderStatus } from '@/model';

import OrderChip from '@/components/order/OrderChip.vue';
import RygenMultiSelect from '@rygen/rygen-ui/components/form/RygenMultiSelect.vue';

const props = defineProps({
  id: {
    type: String,
    default: () => useUid('order-status-multi-select').uid,
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: string[]): void;
}>();

const attrs = useAttrs();
const { t } = useI18n();

const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<string[]>) => opts,
});

const placeholder = computed(() => {
  return (
    (attrs.placeholder as string) ??
    t('common.paramStatuses', { param: t('orders.orders') })
  );
});

const options = mapEnumToTranslatedDropdownValues(OrderStatus, 'OrderStatus');
</script>
